import React, { lazy, useEffect } from "react";
import "./App.css";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
  useLocation,
} from "react-router-dom";
import { themeChange } from "theme-change";
import initializeApp from "./app/init";
import SingleMockTest from "./features/mocktests/components/SingleMockTest";
import SpeakingSection from "./features/mocktests/components/SpeakingSection";
import ListeningPage from "./features/mocktests/components/ListeningPage";
import ReadingPage from "./features/mocktests/components/ReadingPage";
import WritingPage from "./features/mocktests/components/WritingPage";
import SpeakingPage from "./features/mocktests/components/SpeakingPage";
import AttemptResultPage from "./features/mocktests/components/AttemptResultPage";

// Importing pages
const Layout = lazy(() => import("./containers/Layout"));
const Login = lazy(() => import("./pages/Login"));
const ForgotPassword = lazy(() => import("./pages/ForgotPassword"));
const Register = lazy(() => import("./pages/Register"));
const Documentation = lazy(() => import("./pages/Documentation"));
const PaymentCallback = lazy(() => import("./pages/PaymentCallback"));


// Initializing different libraries
initializeApp();

// Auth Guard Component
function AuthGuard({ children }) {
  const location = useLocation();
  const publicRoutes = [
    "/login",
    "/forgot-password",
    "/register",
    "/documentation",
    "/payment-callback",
  ];

  // Check if current route is public
  const isPublicRoute = publicRoutes.includes(location.pathname);

  // Get token from localStorage
  const token = localStorage.getItem("token");

  // If it's a public route, render the children
  if (isPublicRoute) {
    return children;
  }

  // If not a public route and no token, redirect to login
  if (!token) {
    return <Navigate to="/login" replace />;
  }

  // If authenticated, render children
  return children;
}

function App() {
  useEffect(() => {
    // 👆 daisy UI themes initialization
    themeChange(false);
  }, []);

  return (
    <>
      <Router>
        <Routes>

          
          <Route
            path="*"
            element={
              <AuthGuard>
                <Routes>
                  <Route path="/login" element={<Login />} />
                  <Route path="/forgot-password" element={<ForgotPassword />} />
                  <Route path="/register" element={<Register />} />
                  <Route path="/documentation" element={<Documentation />} />
                  <Route path="/payment-callback" element={<PaymentCallback />} />

                  {/* Place new routes over this */}
                  <Route path="/app/*" element={<Layout />} />

                  <Route
                    path="*"
                    element={
                      <Navigate
                        to={
                          localStorage.getItem("token") ? "/app/dashboard" : "/login"
                        }
                        replace
                      />
                    }
                  />

                  <Route path="/mock-test/:testId" element={<SingleMockTest />} />

            <Route
              path="/mock-speaking/:testId"
              element={<SpeakingSection />}
            />

            <Route path="/mock-test/:testId" element={<SingleMockTest />} />
            <Route
              path="/mock-test/:testId/listening"
              element={<ListeningPage />}
            />
            <Route
              path="/mock-test/:testId/reading"
              element={<ReadingPage />}
            />
            <Route
              path="/mock-test/:testId/writing"
              element={<WritingPage />}
            />
            <Route
              path="/mock-test/:testId/speaking"
              element={<SpeakingPage />}
            />
            {/* Attempt Result Route for IELTS */}
            <Route
              path="/mock-test/:testId/attempt/:attemptId/result"
              element={<AttemptResultPage />}
            />

            {/* Direct Speaking Route for IELTS */}
            <Route path="/speaking" element={<SpeakingPage />} />

            {/* Mini Mock Test Routes */}
            <Route
              path="/mini-mock-test/:testId"
              element={<SingleMockTest testType="mini_mock" />}
            />
            <Route
              path="/mini-mock-test/:testId/listening"
              element={<ListeningPage />}
            />
            <Route
              path="/mini-mock-test/:testId/reading"
              element={<ReadingPage />}
            />
            <Route
              path="/mini-mock-test/:testId/writing"
              element={<WritingPage />}
            />
            <Route
              path="/mini-mock-test/:testId/speaking"
              element={<SpeakingPage />}
            />
            <Route
              path="/mini-mock-test/:testId/attempt/:attemptId/result"
              element={<AttemptResultPage />}
            />

            {/* Class Test Routes */}
            <Route
              path="/class-test/:testId"
              element={<SingleMockTest testType="class_test" />}
            />
            <Route
              path="/class-test/:testId/listening"
              element={<ListeningPage />}
            />
            <Route
              path="/class-test/:testId/reading"
              element={<ReadingPage />}
            />
            <Route
              path="/class-test/:testId/writing"
              element={<WritingPage />}
            />
            <Route
              path="/class-test/:testId/speaking"
              element={<SpeakingPage />}
            />
            <Route
              path="/class-test/:testId/attempt/:attemptId/result"
              element={<AttemptResultPage />}
            />

            {/* Bundle Test Routes */}
            <Route
              path="/app/bundles/:bundleId/test/:testId/listening"
              element={<ListeningPage />}
            />
            <Route
              path="/app/bundles/:bundleId/test/:testId/reading"
              element={<ReadingPage />}
            />
            <Route
              path="/app/bundles/:bundleId/test/:testId/writing"
              element={<WritingPage />}
            />
            <Route
              path="/app/bundles/:bundleId/test/:testId/speaking"
              element={<SpeakingPage />}
            />
                </Routes>
              </AuthGuard>
            }
          />
        </Routes>
      </Router>
    </>
  );
}

export default App;
